var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"link":""}},[_c('router-link',{on:{"click":function($event){return _vm.logout()}}},[_vm._v("Ausloggen")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }